<template>
  <w-icon-wrapper
    :width='24'
    :height='23.881'
    icon-name='work-nav-system-configuration-icon'
    view-box='0 0 24 23.881'
  >
    <path
      id="_19_Systemeinstellungen_Icon"
      data-name="19_Systemeinstellungen_Icon"
      d="M86.716-856.119l-.478-3.821a4.532,4.532,0,0,1-.731-.358q-.343-.209-.672-.448l-3.552,1.493L78-864.925l3.075-2.328a2.85,2.85,0,0,1-.03-.4v-.806a2.851,2.851,0,0,1,.03-.4L78-871.194l3.284-5.672,3.552,1.493a8.138,8.138,0,0,1,.687-.448,6,6,0,0,1,.716-.358L86.716-880h6.567l.478,3.821a4.527,4.527,0,0,1,.731.358q.343.209.672.448l3.552-1.493L102-871.194l-3.075,2.328a2.851,2.851,0,0,1,.03.4v.806a1.465,1.465,0,0,1-.06.4l3.075,2.328-3.284,5.672-3.522-1.493a8.139,8.139,0,0,1-.687.448,6.013,6.013,0,0,1-.716.358l-.478,3.821Zm2.09-2.388h2.358l.418-3.164a6.692,6.692,0,0,0,1.716-.7,7.136,7.136,0,0,0,1.448-1.119l2.955,1.224,1.164-2.03-2.567-1.94a4.214,4.214,0,0,0,.209-.881,7.342,7.342,0,0,0,.06-.94,7.342,7.342,0,0,0-.06-.94,4.213,4.213,0,0,0-.209-.881l2.567-1.94-1.164-2.03L94.746-872.6a6.632,6.632,0,0,0-1.448-1.149,6.7,6.7,0,0,0-1.716-.7l-.388-3.164H88.836l-.418,3.164a6.7,6.7,0,0,0-1.716.7,7.136,7.136,0,0,0-1.448,1.119L82.3-873.851l-1.164,2.03,2.567,1.91a4.857,4.857,0,0,0-.209.9,7.237,7.237,0,0,0-.06.955,7,7,0,0,0,.06.925,4.86,4.86,0,0,0,.209.9l-2.567,1.94,1.164,2.03,2.955-1.254a6.632,6.632,0,0,0,1.448,1.149,6.692,6.692,0,0,0,1.716.7Zm1.254-5.373a4.027,4.027,0,0,0,2.955-1.224,4.027,4.027,0,0,0,1.224-2.955,4.027,4.027,0,0,0-1.224-2.955,4.027,4.027,0,0,0-2.955-1.224,4.013,4.013,0,0,0-2.97,1.224,4.052,4.052,0,0,0-1.209,2.955A4.052,4.052,0,0,0,87.09-865.1,4.013,4.013,0,0,0,90.06-863.881ZM90-868.06Z"
      transform="translate(-78 880)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavSystemConfiguration' };
</script>

